import type { OtsColorScheme } from '../theme/OtsTheme';

/**
 * Categorical series colors, in the fixed order series take them: a chart's first series is always blue, its second
 * orange, and so on, so a series keeps its color when others are hidden. Each mode is its own stepped set, checked
 * for color-blind separation and contrast against that mode's surface (the dataviz palette validator); light mode's
 * third hue is under 3:1 on its own, so charts that use it give a legend and a table view.
 */
export const OTS_SERIES_COLORS: Record<OtsColorScheme, readonly string[]> = {
  light: ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#6250d6', '#e34948'],
  dark: ['#3987e5', '#d95926', '#199e70', '#c98500', '#d55181', '#008300', '#9085e9', '#e66767'],
};

/** The color for a series' fixed slot; past eight, series should fold into "Other" rather than wrap around. */
export const otsSeriesColor = (slot: number, scheme: OtsColorScheme) =>
  OTS_SERIES_COLORS[scheme][Math.min(slot, OTS_SERIES_COLORS[scheme].length - 1)];
